import { STORAGE_KEY_THEME_MODE } from '@/utils/storage';
import { useLocalStorageState } from 'ahooks';
import { ThemeMode } from 'antd-style';

export const useThemeMode = () => {
  const [themeMode, setThemeMode] = useLocalStorageState<ThemeMode>(STORAGE_KEY_THEME_MODE, {
    defaultValue: 'auto',
    deserializer: v => v as ThemeMode,
    serializer: v => v,
    listenStorageChange: true,
  });
  return [themeMode, setThemeMode] as const;
};
